import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { StrategicSuggestionsProvider } from './contexts/StrategicSuggestionsContext';
import { ConfigProvider } from './contexts/ConfigContext';

console.log = () => { };
window.alert = function () { };

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider>
      <StrategicSuggestionsProvider>
        <App />
      </StrategicSuggestionsProvider>
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
